import {useDispatch, useSelector} from "react-redux";
import {Button, Spin, Typography, Card, Row, Col, Statistic, Empty, Pagination, Space, Tooltip, Progress} from "antd";
import api from "../api";
import {useEffect, useState} from "react";
import QuestionItem from "../Quiz/Fragments/QuestionItem";
import {Helmet} from "react-helmet-async";
import {useTranslation} from "react-i18next";
import {StarFilled, RightOutlined, SwapOutlined, DeleteOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import ChatPromoBanner from "../Fragments/ChatPromoBanner";
import ScriptAd from "../ScriptAd";

const { Title, Paragraph, Text } = Typography;

function Favorites({analytics}){
    const [loading, setLoading] = useState(false);
    const [question, setQuestion] = useState(null);
    const { t } = useTranslation();
    const [answered, setAnswered] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const favorites = useSelector((state) => state.favorites || [])
    const dispatch = useDispatch();
    
    useEffect(() => {
        analytics()
    }, [])

    useEffect(() => {
        if (favorites.length > 0) {
            if (currentPage > favorites.length) {
                setCurrentPage(favorites.length || 1);
            } else {
                fetchQuestion(currentPage);
            }
        } else {
            setQuestion(null);
        }
    }, [favorites, currentPage])

    const fetchQuestion = (page) => {
        setAnswered(false)
        setQuestion(null)
        const questionId = favorites[page - 1];
        if (questionId) {
            setLoading(true)
            api.API.get(api.Question + `/${questionId}`).then(question => {
                setQuestion(question)
                setLoading(false)
            }).catch(() => {
                setLoading(false);
            })
        }
    }

    const handleNext = (variant) => {
        setAnswered(variant)
    }

    const onPageChange = (page) => {
        setCurrentPage(page);
    }

    const handleNextQuestion = () => {
        if (currentPage < favorites.length) {
            setCurrentPage(currentPage + 1);
        } else {
            setCurrentPage(1);
        }
    }

    const handleShuffle = () => {
        if (favorites.length > 1) {
            const randomIndex = Math.floor(Math.random() * favorites.length) + 1;
            if (randomIndex === currentPage) {
                fetchQuestion(currentPage); // Force reload if same page
            } else {
                setCurrentPage(randomIndex);
            }
        }
    }

    const progressPercent = favorites.length > 0 ? Math.round((currentPage / favorites.length) * 100) : 0;

    return (
        <div className="favorites-container" style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
            <Helmet>
                <title>AvtoDas - {t('header.favorites')}</title>
            </Helmet>

         {/*   <ScriptAd scriptUrl={'https://pl28772667.effectivegatecpm.com/49/ee/ea/49eeeaf9b0d350a53916971b7e02f91e.js'}/>
            <ScriptAd scriptUrl={'https://flaskledgeheadquarters.com/c6/ee/1e/c6ee1ebe112c3166dd00a4273faba949.js'}/>*/}
            <div style={{ marginBottom: 30 }}>
                <Row gutter={[16, 16]} align="bottom">
                    <Col xs={24} sm={16}>
                        <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 12 }}>
                            <StarFilled style={{ color: '#fadb14' }} />
                            {t('header.favorites')}
                        </Title>
                        <Paragraph type="secondary" style={{ marginTop: 8, fontSize: 16 }}>
                            Ձեր կողմից առանձնացված կարևոր հարցերի հավաքածուն
                        </Paragraph>
                    </Col>
                    <Col xs={24} sm={8} style={{ textAlign: 'right' }}>
                        <Space size="large">
                            <Statistic 
                                title="Ընդհանուր" 
                                value={favorites.length} 
                                valueStyle={{ color: '#1890ff', fontWeight: 'bold' }}
                            />
                        </Space>
                    </Col>
                </Row>
                <Progress 
                    percent={progressPercent} 
                    showInfo={false} 
                    strokeColor="#fadb14" 
                    trailColor="#f0f0f0"
                    style={{ marginTop: 15 }}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5 }}>
                    <Text type="secondary" size="small">Հարց {currentPage} / {favorites.length}</Text>
                    <Text type="secondary" size="small">{progressPercent}% ավարտված</Text>
                </div>
            </div>

            <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'center' }}>
                <Card size="small" style={{ borderRadius: 20, background: '#fafafa', border: '1px solid #f0f0f0' }}>
                    <Space size="middle">
                        <Tooltip title="Պատահական հարց">
                            <Button 
                                icon={<SwapOutlined />} 
                                onClick={handleShuffle}
                                disabled={favorites.length <= 1}
                            >
                                Խառնել
                            </Button>
                        </Tooltip>
                        <div style={{ width: 1, height: 20, background: '#ddd' }} />
                        <Pagination
                            simple
                            current={currentPage}
                            total={favorites.length}
                            pageSize={1}
                            onChange={onPageChange}
                        />
                    </Space>
                </Card>
            </div>

            <Spin spinning={loading} size="large" tip="Բեռնվում է...">
                {question ? (
                    <div className="animate-in">
                        <QuestionItem 
                            quick_view={true} 
                            currentQuestion={question} 
                            handleNext={handleNext} 
                            value={answered} 
                            noSubmit={answered !== false}
                        />
                        
                        <div style={{ 
                            marginTop: 30, 
                            padding: '20px',
                            background: '#fff',
                            borderRadius: 16,
                            boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                            textAlign: 'center'
                        }}>
                            <Row gutter={[16, 16]} justify="center" align="middle">
                                <Col xs={24} md={16}>
                                    <Pagination
                                        current={currentPage}
                                        total={favorites.length}
                                        pageSize={1}
                                        onChange={onPageChange}
                                        showSizeChanger={false}
                                        showQuickJumper
                                        style={{ display: 'inline-block' }}
                                    />
                                </Col>
                                {answered !== false && (
                                    <Col xs={24} md={8}>
                                        <Button 
                                            size="large" 
                                            type="primary" 
                                            icon={<RightOutlined />} 
                                            onClick={handleNextQuestion}
                                            style={{ 
                                                minWidth: 150, 
                                                borderRadius: 10, 
                                                height: 45, 
                                                background: '#52c41a',
                                                borderColor: '#52c41a',
                                                boxShadow: '0 4px 10px rgba(82, 196, 26, 0.3)'
                                            }}
                                        >
                                            {currentPage < favorites.length ? t('questions.next') : 'Կրկնել'}
                                        </Button>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    </div>
                ) : (
                    !loading && (
                        <Card style={{ textAlign: 'center', padding: '40px 0', borderRadius: 20 }}>
                            <Empty 
                                image={Empty.PRESENTED_IMAGE_SIMPLE} 
                                description={
                                    <div style={{ marginBottom: 20 }}>
                                        <Title level={4} type="secondary">Դուք դեռ չունեք նախընտրելի հարցեր</Title>
                                        <Paragraph type="secondary">
                                            Թեստերը լուծելիս սեղմեք աստղիկի վրա՝ կարևոր հարցերը այստեղ պահպանելու համար:
                                        </Paragraph>
                                    </div>
                                }
                            >
                                <Button 
                                    type="primary" 
                                    size="large" 
                                    onClick={() => window.location.href = '/quizes'}
                                    style={{ borderRadius: 10, height: 50, minWidth: 200 }}
                                    icon={<QuestionCircleOutlined />}
                                >
                                    {t('questions.tests')}
                                </Button>
                            </Empty>
                        </Card>
                    )
                )}
            </Spin>
            
            <style jsx>{`
                .animate-in {
                    animation: fadeIn 0.5s ease-out;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .favorites-container :global(.ant-pagination-simple-pager) {
                    font-weight: bold;
                }
            `}</style>
        </div>
    )
}

export default Favorites;
